import { PriceUpdateAPIResponse } from '@/types/stores.types';
import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import { AlertCircle, CheckCircle, Info } from 'react-feather';

const FAILED = 'FAILED';

export enum EntityToUpdate {
  'MENU' = 'MENU',
  'BUNDLE_UC' = 'BUNDLE_UC',
  'BUNDLE_UC_STORE_GROUPS' = 'BUNDLE_UC_STORE_GROUPS',
}

function splitArray(toSplit: string[] = []) {
  const middleIndex = Math.ceil(toSplit.length / 2);
  const firstHalf = toSplit.slice(0, middleIndex);
  const secondHalf = toSplit.slice(middleIndex);
  return [firstHalf, secondHalf];
}

export const EditDrawerSuccessAndFailure = ({
  apiResponse,
  entityToUpdate,
}: {
  apiResponse: PriceUpdateAPIResponse;
  entityToUpdate: string;
}) => {
  const [failedStoresOne, failedStoresTwo] = splitArray(apiResponse?.failedStores);

  // Check if successStoresCount is 0 OR missing/undefined (for exception cases)
  return apiResponse.successStoresCount === 0 ||
    apiResponse.successStoresCount === undefined ||
    apiResponse.successStoresCount === null ? (
    <Grid
      container
      direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid container direction="row" md={6}>
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
          <Grid item>
            {/* Show Info icon for timeout, AlertCircle for errors */}
            {apiResponse?.status === 'TIMEOUT' ? (
              <Info color="var(--blue-600)" />
            ) : (
              <AlertCircle color="var(--red-700)" />
            )}
          </Grid>
          <Grid item>
            <Typography fontSize="2.0rem" fontWeight={700} pl={1} data-testid="totalFailure">
              {/* Show timeout message if status is TIMEOUT, otherwise show failure message */}
              {apiResponse?.status === 'TIMEOUT'
                ? apiResponse?.message || t('requestProcessingModal.timeout.message')
                : t(
                    entityToUpdate === EntityToUpdate.MENU
                      ? 'editMenuPrice.allMenusFailedTitle'
                      : 'bundleUpcharges.editDrawer.allStoresFailed',
                  )}
            </Typography>
          </Grid>
        </Grid>
        {/* Don't show "try again" message for timeout cases */}
        {apiResponse?.status !== 'TIMEOUT' && (
          <Grid container direction="column" pt={1}>
            <Grid item fontSize="2.0rem">
              {t('common.tryAgain')}
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  ) : (
    <Grid
      container
      direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid container direction="row" md={6}>
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
          <Grid item>
            <CheckCircle color="var(--green-500)" />
          </Grid>
          <Grid item>
            <Typography fontSize="2.0rem" fontWeight={700} pl={1} data-testId="partialSuccess">
              {entityToUpdate === EntityToUpdate.MENU
                ? t('editMenuPrice.menusUpdated', { count: apiResponse.successStoresCount })
                : t('bundleUpcharges.editDrawer.storesUpdated', { count: apiResponse.successStoresCount })}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {apiResponse.status === FAILED && (
        <Grid container direction="row" md={6}>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center" pt={2}>
            <Grid item>
              <Info color="var(--red-700)" />
            </Grid>
            <Grid item>
              <Typography fontSize="2.0rem" component="span" fontWeight={700} pl={1}>
                {entityToUpdate === EntityToUpdate.MENU
                  ? t('editMenuPrice.menusFailed', { count: apiResponse?.failedStores.length })
                  : t('bundleUpcharges.editDrawer.storesFailed', { count: apiResponse?.failedStores.length })}
              </Typography>
            </Grid>
          </Grid>
          <div style={{ display: 'flex', paddingLeft: '20px', paddingTop: '8px', gap: '24px' }}>
            <div data-testid="partialFailure">
              <ul style={{ listStyle: 'unset', fontSize: '1.5em', margin: 0, minWidth: 'fit-content' }}>
                {failedStoresOne.map((failedStore) => (
                  <li key={failedStore}>
                    <Typography component="p" fontSize="1.8rem" pl={0}>
                      {failedStore}
                    </Typography>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <ul style={{ listStyle: 'unset', fontSize: '1.5em', margin: 0, minWidth: 'fit-content' }}>
                {failedStoresTwo.map((failedStore) => (
                  <li key={failedStore}>
                    <Typography component="p" fontSize="1.8rem" pl={0}>
                      {failedStore}
                    </Typography>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Grid>
      )}
    </Grid>
  );
};
